import { styled } from '@mui/system';

import { Box, Stack } from '@mui/material';

import { fontFamilies } from '../../../../../constants/theme';
import { SectionHeading } from '../../../Splash/styles';

export const HeroSection = styled(Box)(({ theme }) => ({
  color: '#4c2e1f',
  [theme.breakpoints.down('md')]: {
    textAlign: 'center',
  },
}));

export const HeroContainer = styled(Box)(({ theme }) => ({
  maxWidth: '1000px',
  margin: '0 auto',
  [theme.breakpoints.down('md')]: {
    padding: '0 20px',
  },
  [theme.breakpoints.down('sm')]: {
    padding: '0 16px',
  },
}));

export const HeroTitle = styled(SectionHeading)(({ theme }) => ({
  ...theme.typography.heading,
  fontSize: '60px',
  fontWeight: '400',
  letterSpacing: '-.4px',
  lineHeight: '77px',
  textAlign: 'start !important',
  [theme.breakpoints.down('lg')]: {
    fontSize: '50px',
    lineHeight: '64px',
  },
  [theme.breakpoints.down('md')]: {
    textAlign: 'center !important',
    fontSize: '36px',
    lineHeight: '46px',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '28px',
    lineHeight: '36px',
  },
}));

export const HeroSubtitle = styled('p')(({ theme }) => ({
  fontSize: '18px',
  marginTop: '17px',
  letterSpacing: '-1.6px',
  fontFamily: fontFamilies.quicksand,
  fontWeight: 400,

  [theme.breakpoints.up('sm')]: {
    fontSize: theme.spacing(3.875),
  },
  [theme.breakpoints.up('md')]: {
    fontSize: theme.spacing(5.125),
  },
}));

export const HeroText = styled('p')(({ theme }) => ({
  fontWeight: 400,
  marginTop: '30px',
  letterSpacing: '-.1px',
  fontFamily: fontFamilies.quicksand,
  fontSize: '18px',
  [theme.breakpoints.up('sm')]: {
    fontSize: '22px',
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '28px',
  },
  [theme.breakpoints.down('sm')]: {
    marginTop: '20px',
  },
}));

export const HeroTextSecondary = styled('p')(({ theme }) => ({
  whiteSpace: 'pre-line',
  fontWeight: 400,
  marginTop: '15px',
  lineHeight: '35px',
  fontSize: '18px',
  fontFamily: fontFamilies.quicksand,
  [theme.breakpoints.up('sm')]: {
    fontSize: '22px',
    lineHeight: '32px',
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '28px',
    lineHeight: '35px',
  },
  [theme.breakpoints.down('sm')]: {
    lineHeight: '28px',
    marginTop: '12px',
  },
}));

export const PillsContainer = styled(Stack)(({ theme }) => ({
  marginTop: '20px',
  gap: '14px',
  [theme.breakpoints.down('md')]: {
    marginTop: '16px',
    gap: '12px',
  },
  [theme.breakpoints.down('sm')]: {
    marginTop: '14px',
    gap: '10px',
  },
}));

export const pillStyles = {
  minHeight: { md: '73px', xs: '65px' },
};

export const pillTextStyles = {
  fontSize: { md: '20px', xs: '18px' },
};
